import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-pause-dispense-page',
  templateUrl: './pause-dispense-page.component.html',
  styleUrls: ['./pause-dispense-page.component.css']
})
export class PauseDispensePageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
